import { createApp } from 'vue'
import App from './App.vue'
import Quasar from 'quasar/src/vue-plugin.js';
import router from './router'
import store from './store'
import quasarUserOptions from './quasar-user-options'

createApp(App).use(store).use(router).use(Quasar, quasarUserOptions, router, store).mount('#app')
